import languages from '../languages';
// 从链接获取language 语言，并且对文案进行初始化。
languages.init();

const getCurLanguageList = () => {
  let resList = languages.getLangText();
  return resList;
};

export default {
  state: {
    languageList: getCurLanguageList(),
    curLang: languages.language,
    isRtlDirection: languages.isRtlDirection()
  },
  mutations: {
    switchLang(state, lang) {
      languages.setLanguage(lang);
      state.curLang = languages.language;
      state.isRtlDirection = languages.isRtlDirection();
    }
  }
};
